import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { Paths } from 'src/pages/paths';
import { router } from 'src';
import { recordPageView } from '.';
import { getQueryParams } from 'src/helpers/history';
import { ProcurementsDisplay } from '../models/procurements/types';

const PATH_WITH_ID = Object.values(Paths).filter(p => /:.+/.test(p));

const handlePageWithId = (pathname: string, matchedPath: string): boolean => {
  const PageViewWithId = matchPath({ path: matchedPath }, pathname);
  if (PageViewWithId) {
    // TODO: @check
    recordPageView({
      pageId:
        PageViewWithId.pathname === Paths.PROCUREMENT_DETAILS_PAGE
          ? Paths.TENDER_PAGE
          : PageViewWithId.pathname /*(pathnameBase??)*/
    });
    return true;
  }
  return false;
};

const handleDetailsTable = (pathname: string, qp: Partial<Record<string, unknown>>): boolean => {
  const isDetailTablePage = matchPath({ path: Paths.PROCUREMENT_DETAILS_PAGE }, pathname);
  // handle /details/table?tab=<ProcurementDisplay> => /details/table/<ProcurementDisplay>
  // No Tab or root path => ProcurementsDisplay.MATCHED
  if (isDetailTablePage || pathname === '/') {
    const { tab } = qp;
    recordPageView({ pageId: `${Paths.PROCUREMENT_TABLE_PAGE}/${tab ?? ProcurementsDisplay.MATCHED}` });
    return true;
  }
  return false;
};

const handler = (pathname: string, qp: Partial<Record<string, unknown>>): void => {
  let isMatched = false;
  PATH_WITH_ID.forEach(p => {
    if (handlePageWithId(pathname, p)) {
      isMatched = true;
    }
  });
  if (isMatched || handleDetailsTable(pathname, qp)) return;
  recordPageView({ pageId: pathname });
};

export function useRumPageWatcher(): void {
  const location = useLocation();
  useEffect(() => {
    const qp = getQueryParams();
    const unregister = router.subscribe(state => {
      const qp = getQueryParams();
      handler(state.location.pathname, qp);
    });
    handler(location.pathname, qp);

    return () => {
      unregister();
    };
  }, [location.pathname]);
}

export default useRumPageWatcher;
